import { injectable } from 'inversify';

import { AuthRepository } from '@vp/auth/core/interface/AuthRepository';
import { TokensStorage } from '@vp/auth/core/interface/TokensStorage';
import { LoadOwnerUsecase } from '@vp/auth/core/usecase/LoadOwnerUsecase';
import { Failure, OperationResult, Success } from '@vp/common/core/OperationResult';
import { LoadProfilesUsecase } from '@vp/manager/profile/core/usecase/LoadProfilesUsecase';

@injectable()
export class RegisterUsecase {
  constructor(
    private readonly authRepository: AuthRepository,
    private readonly tokensStorage: TokensStorage,
    private readonly loadOwnerUsecase: LoadOwnerUsecase,
    private readonly loadProfilesUsecase: LoadProfilesUsecase,
  ) {}

  async execute(email: string, password: string, controller?: AbortController): Promise<OperationResult> {
    const result = await this.authRepository.register(email, password, controller);

    if (result instanceof Failure) {
      return result;
    }

    await this.tokensStorage.store(result.value);
    await this.loadOwnerUsecase.execute(controller);
    await this.loadProfilesUsecase.execute(controller);

    return Success.empty();
  }
}
